module.exports = __webpack_public_path__ + "img/国际认证.c249df17.png";